import { DbRef, UNKNOWN_SCHEDULING_USER } from '@caresend/types';
import update from 'immutability-helper';
import { getPath } from './path.js';

/**
 * ```
 * `${DbRef.USERS}/${id}/${childPath}`
 * ```
 */

function getUserPath(id, childPath) {
  return getPath(`${DbRef.USERS}/${id}`, childPath);
}
const getUserHasPlaceRole = (userPlaces, placeID, role) => {
  var _a;

  return !!((_a = userPlaces === null || userPlaces === void 0 ? void 0 : userPlaces[placeID]) === null || _a === void 0 ? void 0 : _a.placeRoles[role]);
};
/**
 * Given the needed arguments, returns a `UserPlace` which can be set at
 * `${DbRef.USERS}/${id}/places/${placeID}`, either as a new object or replacing
 * the existing one (if the user already has a different role for that place)
 */

const addUserPlaceRole = (userPlaces, placeID, role) => {
  var _a;

  const userPlace = (_a = userPlaces === null || userPlaces === void 0 ? void 0 : userPlaces[placeID]) !== null && _a !== void 0 ? _a : {
    id: placeID,
    placeRoles: {}
  };
  const updatedUserPlace = update(userPlace, {
    placeRoles: {
      [role]: {
        $set: true
      }
    }
  });
  return updatedUserPlace;
};
const shouldEncryptSchedulingUserName = schedulingUserName => schedulingUserName.toLowerCase() !== UNKNOWN_SCHEDULING_USER.toLowerCase();

export { addUserPlaceRole, getUserHasPlaceRole, getUserPath, shouldEncryptSchedulingUserName };
